import React from "react";
import Charts from "../charts";
import styles from "../DetailsTab.module.css";

/**
 * ChartsPanel — outer card shell for the BP chart + (TH-A4) distribution bars.
 *
 * Layout-pass scope (TH-A1): wraps the existing <Charts /> in card chrome.
 * Hides Charts' internal RPM/CCM TabList because the page-level RpmCcmToggle
 * already handles that scope; passes `chatBotType` as `forcedTab` so the
 * panel below renders the right view (RPM = Readings, CCM = CarePlanNew).
 *
 * The Average BP / Heart Rate distribution bar slots stay empty here and
 * land in subtask TH-A4.
 */
const ChartsPanel = ({
  patientId,
  isOpen,
  onClose,
  handlePatientType,
  setChatBotType,
  isCcmChatStarted,
  onStartTocaCopilot,
  patientType,
  chatBotType,
}) => {
  return (
    <div className={`${styles.card} ${styles.chartsCard}`}>
      <Charts
        patientId={patientId}
        isOpen={isOpen}
        onClose={onClose}
        handlePatientType={handlePatientType}
        setChatBotType={setChatBotType}
        isCcmChatStarted={isCcmChatStarted}
        onStartTocaCopilot={onStartTocaCopilot}
        patientType={patientType}
        hideToggle={true}
        forcedTab={chatBotType}
        compactToolbar={true}
      />
    </div>
  );
};

export default ChartsPanel;
